import { useEffect, useMemo, useRef, useState } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import Switch from '../../components/common/Switch/Switch';
import Level from '../../components/exersize/Level/Level';

import cn from 'classnames';
import { ReactComponent as SvgExpand } from '../../aassets/ic/ui/ic_expand.svg';
import { ReactComponent as SvgSendTimer } from '../../aassets/img/send-timer.svg';
import Button from '../../components/common/Button/Button';

import '../../styles/pageModules/quiz.scss';
import '../../styles/vendor/katex/katex.min.css';
import '../../styles/vendor/suneditor.min.css';
import s from './quiz.module.scss';

import Modal from 'react-modal';
import { Link, useLoaderData, useLocation } from 'react-router-dom';
import BundleContent from '../../components/quiz/BundleContent/BundleContent';
import SingleQuestion from '../../components/quiz/SingleQuestion/SingleQuestion';
import {
	AnswerID,
	BundleStr,
	DBBooleanStr,
	QMap,
	QuestionStr,
	QuizeResponse,
	QuizState,
	Q_STATUS,
	ReactPressVars,
} from '../../types';

//@ts-ignore
import $ from 'jquery';

//@ts-ignore
import { useMedia } from 'react-use';
import StopWatch from '../../components/quiz/StopWhatch/StopWhatch';

interface SaveQuestonStats {
	question_id: string;
	status: number;
	solving_time: number;
	selected_ans_id: AnswerID | null;
}
interface SaveUserStats {
	category_id: string;
	is_700: DBBooleanStr;
	value: string | null;
}
interface RenderTimeProps {
	remainingTime: number;
}
interface Props {
	root: HTMLElement;
	wpdata: ReactPressVars;
	isDev: boolean;
}

const Quiz2 = ({ root, wpdata, isDev }: Props) => {
	const isModile = useMedia('(max-width: 430px)');
	// Imgs modal
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalContent, setModalContent] = useState<HTMLElement>();
	const openModal = (content: any) => {
		setModalContent(content);
		setModalIsOpen(true);
	};
	const handleImgClick = (e: MouseEvent, el: HTMLElement) => {
		e.preventDefault();
		e.stopPropagation();

		openModal(el);
	};

	// user defined times
	const locationState = useLocation().state;
	const times = locationState.times as {
		category_id: number;
		time: number;
	}[];
	//
	//Timers
	const usingTimes = locationState.useTimes as boolean;
	const [isNoneStop, setIsNoneStop] = useState(false);
	const [isPlaing, setIsPlaying] = useState(usingTimes);
	const [showTimer, setShowTimer] = useState(true);
	//
	//

	//timer modal
	const [timeModalIsOpen, setTimeModalIsOpen] = useState(false);
	const [showTimeModal, setShowTimeModal] = useState(true);
	const closeTimeModal = (action: 'next' | 'show-solution') => {
		action === 'show-solution'
			? setShowSolution(true)
			: moveToNextQuestion('time');
		setTimeModalIsOpen(false);
	};
	//
	// data

	const usedQuestions = useRef<QuestionStr[]>([]);
	const usedQuestionIds = useRef<string[]>([]);
	const usedBundles = useRef<BundleStr[]>([]);
	const addUsedQuestion = (q: QuestionStr, addBundle: boolean) => {
		usedQuestions.current.push(q);

		usedQuestionIds.current.push(q.id);
		if (currBundle && addBundle) {
			const found = usedBundles.current.find(
				(b) => b.id === currBundle.id
			);
			if (!found) {
				usedBundles.current.push(currBundle);
			}
		}
	};

	const { pid, quizCats, qCount, userLvls } =
		useLoaderData() as QuizeResponse;

	quizCats.forEach((qc) => {
		//TODO: move to useref or usememo

		//TODO: replace value after ??
		qc.catData.time =
			times.find((t) => t.category_id === parseInt(qc.catData.id))
				?.time ?? 10;
	});

	const [totalQuestionsLeft, setTotalQuestionsLeft] = useState(qCount);
	const [currQuizIndex, setCurrQuizIndex] = useState(0);

	const currQuiz = useMemo(
		() => quizCats[currQuizIndex],
		[currQuizIndex, quizCats]
	);
	const { questionsMap, bundlesMap, catData } = currQuiz;

	const allQuestionsData = useMemo(() => {
		return quizCats.map((qc, i) => {
			const currQuestionMap = Object.values(qc.questionsMap);
			let count = 0;
			for (let i = 0; i < currQuestionMap.length; i++) {
				count += currQuestionMap[i].length;
			}
			return {
				pointers: Array(qc.catData.level.max_value).fill(0) as number[],
				lengths: Object.values(qc.questionsMap).map((qm) => qm.length),
				questionsLeft: count,
			};
		});
	}, [quizCats]);

	const [isTimed, setIsTimed] = useState(false);
	const [showSolution, setShowSolution] = useState(false);

	const [state, setState] = useState<QuizState>({
		lvl: userLvls[currQuizIndex].value,
		qMap: allQuestionsData[currQuizIndex],
	});

	const questions = useMemo(
		() => questionsMap[state.lvl.toString()],
		[state.lvl, questionsMap]
	);
	const question = questions[state.qMap.pointers[state.lvl - 1]];

	// Bundle handling
	const [currBundle, setCurrBundle] = useState<BundleStr | undefined>();
	const [bundleStarted, setBundleStarted] = useState(false);
	const [bundleExpanded, setBundleExpanded] = useState(
		currBundle ? true : false
	);
	const [bundleResults, setBundleResults] = useState<number[]>([]);
	const currTimeDown = useRef(0);
	const currTimeDownBundle = useRef(0);
	const currTimeUp = useRef(0);
	const currTimeUpBundle = useRef(0);

	const startBundle = () => {
		setBundleStarted(true);
		setBundleExpanded(false);
	};
	const stopBundle = () => {
		setBundleStarted(false);
		setBundleExpanded(true);
		setBundleResults([]);
	};
	// Timers

	// Countdoun timer
	const [timerKey, setTimerKey] = useState(0);
	const RenderTime = ({ remainingTime }: RenderTimeProps) => {
		if (currTimeDown.current !== remainingTime) {
			currTimeDown.current = remainingTime;
		}

		return useMemo(
			() => <span className={s.timer_counter}>{remainingTime}</span>,
			[currTimeDown.current]
		);
	};
	// StopWatch
	const [swIsPlayinbg, setSwIsPlaying] = useState(!usingTimes);
	const [swReset, setSwReset] = useState(false);
	const getTimePassedCallBack = (time: string) => {
		const times = time.split(':');
		currTimeUp.current =
			parseInt(times[2]) +
			parseInt(times[1]) * 60 +
			parseInt(times[0]) * 360;
	};
	const stopWatchId = useMemo(
		() => (currBundle ? `b${currBundle.id}` : `q${question.id}`),
		[currBundle, question]
	);
	if (question.bundle_id) {
		if (!currBundle || currBundle.id !== question.bundle_id) {
			setCurrBundle(
				bundlesMap[state.lvl.toString()].find(
					(b) => b.id === question.bundle_id
				)
			);
			stopBundle();

			if (usingTimes) {
				currTimeDown.current = currQuiz.catData.time;
				currTimeDownBundle.current = 0;
				setIsPlaying(true);
			} else {
				// currentTimeUp.current = currQuiz.catData.time;
				setSwIsPlaying(true);
				currTimeUp.current = 0;
			}
		}
	} else {
		if (currBundle) {
			setCurrBundle(undefined);
		}
	}
	const showQuestion = useMemo(
		() => (!currBundle || (currBundle && bundleStarted) ? true : false),
		[currBundle, bundleStarted]
	);
	// end bundle

	// quiz functions
	//
	const moveToNextQuiz = () => {
		if (totalQuestionsLeft > 0) {
			const newQuizInd = currQuizIndex + 1;
			if (newQuizInd < quizCats.length) {
				const cdata = quizCats[newQuizInd].catData;
				let newLvl = userLvls.find(
					(l) =>
						l.category_id === parseInt(cdata.id) &&
						l.is_700 === cdata.is_700
				);
				if (!newLvl) {
					throw new Error('lvl not found');
				}

				setCurrQuizIndex(newQuizInd);
				setState({
					qMap: allQuestionsData[newQuizInd],
					lvl: newLvl.value,
				});
			}
		}
	};
	//TODO: consider returning value insted of setting state
	const bumpCurrentQuestionPointer = (): QMap => {
		const qMap = { ...state.qMap };

		if (qMap.questionsLeft > 0) {
			const lvl = state.lvl;

			let newQuestionIndex = qMap.pointers[lvl - 1] + 1;
			if (newQuestionIndex < qMap.lengths[lvl - 1]) {
				qMap.pointers[lvl - 1] = newQuestionIndex;
			} else {
				qMap.pointers[lvl - 1] = -1;
			}

			qMap.questionsLeft--;
		}
		return qMap;
	};

	const handleExersizeTime = (isTimed: boolean) => {
		if (question.bundle_id) {
			let timePassed;
			if (usingTimes) {
				timePassed = catData.time - currTimeDown.current;
				question.exersizeTime = (
					timePassed - currTimeDownBundle.current
				).toString();
				currTimeDownBundle.current = timePassed;
			} else {
				timePassed = currTimeUp.current;
				question.exersizeTime = (
					timePassed - currTimeUpBundle.current
				).toString();
				currTimeUpBundle.current = timePassed;
			}
			//last in bundle
			if (
				state.qMap.questionsLeft === 0 ||
				state.qMap.pointers[state.lvl - 1] === -1 ||
				state.qMap.lengths[state.lvl - 1] ===
					state.qMap.pointers[state.lvl - 1] + 1 ||
				question.bundle_id !==
					questions[state.qMap.pointers[state.lvl - 1] + 1].bundle_id
			) {
				if (usingTimes) {
					currTimeDownBundle.current = 0;
				} else {
					currTimeUpBundle.current = 0;
				}
			}
		} else {
			question.exersizeTime = (
				usingTimes
					? currQuiz.catData.time - currTimeDown.current
					: currTimeUp.current
			).toString();
		}
	};

	const onAnswerSelectCallback = (
		isRight: boolean,
		selected_ans_id: AnswerID
	) => {
		question.status = isRight ? Q_STATUS.RIGHT : Q_STATUS.WRONG;
		question.selected_ans_id = selected_ans_id;

		handleExersizeTime(false);
		addUsedQuestion(question, question.bundle_id ? true : false);

		saveQuestonStats({
			question_id: question.id,
			status: question.status,
			solving_time: parseInt(question.exersizeTime ?? '0'),
			selected_ans_id: question.selected_ans_id,
		});
		if (usingTimes) {
			if (!currBundle) {
				setIsPlaying(false);
			}
		} else {
			if (!currBundle) {
				setSwIsPlaying(false);
			}
		}
		if (isNoneStop) {
			setTimeout(() => {
				moveToNextQuestion('click');
			}, 2000);
		}
	};

	const onTimeEnd = () => {
		setIsTimed(true);
		question.status = Q_STATUS.TIMED;
		handleExersizeTime(true);
		addUsedQuestion(question, question.bundle_id ? true : false);
		saveQuestonStats({
			question_id: question.id,
			status: Q_STATUS.TIMED,
			solving_time: parseInt(question.exersizeTime ?? '0'),
			selected_ans_id: null,
		});

		if (showTimeModal) {
			setTimeout(() => {
				setTimeModalIsOpen(true);
			}, 2000);
		} else if (isNoneStop) {
			setTimeout(() => {
				moveToNextQuestion('time');
			}, 2000);
		}
	};

	const moveToNextQuestion = (reason: 'time' | 'click') => {
		const isRight = question.status === Q_STATUS.RIGHT;
		let lastInBundle = false;
		if (totalQuestionsLeft > 0) {
			let isQuizFinished = totalQuestionsLeft === 2 ? true : false;

			if (state.qMap.questionsLeft > 0) {
				const newQMap = bumpCurrentQuestionPointer();
				let newLvl = state.lvl;

				//single
				if (question.bundle_id === null) {
					if (newQMap.questionsLeft === 0) {
						isQuizFinished = true;
					} else {
						//wrog answer
						if (!isRight) {
							newLvl = getNewLvl([1, 1], newQMap);
						}
						//right answer
						else {
							newLvl = getNewLvl([0], newQMap);
						}
						if (newLvl === state.lvl) {
							if (isRight) {
								if (newQMap.pointers[newLvl - 1] === -1)
									newLvl = getNewLvl([1, 1], newQMap);
							} else {
								if (newQMap.pointers[newLvl - 1] === -1) {
									newLvl = getNewLvl([0], newQMap);
								}
							}
						}

						setState({ ...state, qMap: newQMap, lvl: newLvl });
					}
				}
				//bundle
				else {
					const newBundleResults = bundleResults;
					newBundleResults.push(isRight ? 0 : 1);
					//last in bundle
					if (
						newQMap.questionsLeft === 0 ||
						newQMap.pointers[state.lvl - 1] === -1 ||
						(questions[newQMap.pointers[state.lvl - 1]] &&
							question.bundle_id !==
								questions[newQMap.pointers[state.lvl - 1]]
									.bundle_id)
					) {
						lastInBundle = true;

						if (newQMap.questionsLeft === 0) {
							isQuizFinished = true;
						} else {
							newLvl = getNewLvl(newBundleResults, newQMap);
							//wrog answer
							if (!isRight) {
								newLvl = getNewLvl([1, 1], newQMap);
							}
							//right answer
							else {
								newLvl = getNewLvl([0], newQMap);
							}
							if (newLvl === state.lvl) {
								if (isRight) {
									if (newQMap.pointers[newLvl - 1] === -1)
										newLvl = getNewLvl([1, 1], newQMap);
								} else {
									if (newQMap.pointers[newLvl - 1] === -1) {
										newLvl = getNewLvl([0], newQMap);
									}
								}
							}
							setState({
								...state,
								qMap: newQMap,
								lvl: newLvl,
							});
						}

						stopBundle();
					}

					//same bundle
					else {
						setState({ ...state, qMap: newQMap });
					}
					setBundleResults(newBundleResults);
				} //bundle

				setTotalQuestionsLeft(totalQuestionsLeft - 1);
				setShowSolution(false);
				if (isQuizFinished) {
					moveToNextQuiz();
				}
			} else {
				moveToNextQuiz();
			}
			if (usingTimes) {
				if (question.bundle_id) {
					if (lastInBundle) {
						setTimerKey(timerKey + 1);
					}
				} else {
					setTimerKey(timerKey + 1);
				}
				setIsPlaying(true);
			} else {
				setSwReset(true);
				setSwIsPlaying(true);
			}
		}

		isTimed && setIsTimed(false);
	};

	// if bundled, must be called only at last bundle question
	const getNewLvl = (results: number[], newQMap: QMap) => {
		let newLvl: number;
		let failCount = results.reduce((acc, curr, i) => {
			if (curr !== 0) {
				return acc + 1;
			}
			return acc;
		}, 0);
		// move level down
		//TODO: handle different rates in different cats
		if (failCount > 1) {
			newLvl = toogleLvl('down', newQMap);
		}
		// move level up
		else {
			newLvl = toogleLvl('up', newQMap);
		}

		if (newLvl !== state.lvl) {
			saveUserLvl({
				category_id: question.category_id,
				is_700: question.is_700,
				value: question.is_700 ? question.level_700 : question.level,
			});
		}
		return newLvl;
	};

	// recursive level toogle up/down
	const toogleLvl = (dir: 'up' | 'down', newQMap: QMap): number => {
		if (newQMap.questionsLeft === 0) {
			throw new Error('toogleLvl: no questions left');
		}
		let lvl = state.lvl;

		let newLvl;
		if (dir === 'up') {
			for (let i = lvl; i < catData.level.max_value; i++) {
				if (newQMap.lengths[i] !== 0 && newQMap.pointers[i] !== -1) {
					newLvl = i + 1;
					break;
				}
			}
			if (!newLvl) {
				if (newQMap.pointers[lvl - 1] !== -1) {
					newLvl = lvl;
				} else {
					toogleLvl('down', newQMap);
				}
			}
		} else {
			for (let i = lvl - 2; i >= 0; i--) {
				if (newQMap.lengths[i] !== 0 && newQMap.pointers[i] !== -1) {
					newLvl = i + 1;
					break;
				}
			}
			if (!newLvl) {
				if (newQMap.pointers[lvl - 1] !== -1) {
					newLvl = lvl;
				} else {
					toogleLvl('up', newQMap);
				}
			}
		}

		return newLvl ?? state.lvl;
	};

	const saveUserLvl = async ({
		category_id,
		is_700,
		value,
	}: SaveUserStats) => {
		if (wpdata.user.ID && wpdata.user.ID !== 0) {
			return isDev
				? $.ajax({
						url: `http://adap.local/wp-json/adp-app/set-user-lvl/`,
						method: 'POST',
						data: JSON.stringify({
							uid: wpdata.user.ID,
							pid: pid,
							category_id: category_id,
							is_700: is_700,
							value: value,
						}),
				  }).done(function (response: any) {
						return response;
				  })
				: $.ajax({
						url: `/wp-json/adp-app/set-user-lvl/`,
						method: 'POST',
						//@ts-ignore
						beforeSend: function (xhr) {
							// @ts-ignore
							xhr.setRequestHeader(
								'X-WP-Nonce',
								wpdata.api.nonce
							);
						},
						data: JSON.stringify({
							uid: wpdata.user.ID,
							pid: pid,
							category_id: category_id,
							is_700: is_700 ?? 0,
							value: value,
						}),
				  }).done(function (response: any) {
						return response;
				  });
		}
	};
	const saveQuestonStats = async ({
		question_id,
		status,
		solving_time,
		selected_ans_id,
	}: SaveQuestonStats) => {
		if (wpdata.user.ID && wpdata.user.ID !== 0) {
			return isDev
				? $.ajax({
						url: `http://adap.local/wp-json/adp-app/set-question-stats-for-user/`,
						method: 'POST',
						data: JSON.stringify({
							uid: wpdata.user.ID,
							pid: pid,
							question_id: parseInt(question_id),
							selected_ans_id: selected_ans_id,
							status: status,
							solving_time: solving_time,
						}),
				  }).done(function (response: any) {
						return response;
				  })
				: $.ajax({
						url: `/wp-json/adp-app/set-question-stats-for-user/`,
						method: 'POST',
						//@ts-ignore
						beforeSend: function (xhr) {
							// @ts-ignore
							xhr.setRequestHeader(
								'X-WP-Nonce',
								wpdata.api.nonce
							);
						},
						data: JSON.stringify({
							uid: wpdata.user.ID,
							pid: pid,
							question_id: parseInt(question_id),
							selected_ans_id: selected_ans_id,
							status: status,
							solving_time: solving_time,
						}),
				  }).done(function (response: any) {
						return response;
				  });
		}
	};

	const categories = useMemo(
		() => Object.values(quizCats).map((quizCat) => quizCat.catData),
		[quizCats]
	);

	// Set imgs click to open modal
	useEffect(() => {
		const containers = Array.from(document.getElementsByClassName('ims'));

		containers.forEach((cont) => {
			const figs = Array.from(cont.getElementsByTagName('figure'));
			figs.forEach((fig) =>
				fig.addEventListener('click', (e) => handleImgClick(e, fig))
			);
		});
	}, [question, showSolution]);

	return (
		<>
			<section className={s.rt}>
				<div className={s.hdr}>
					<h2 className={s.title}>תרגול</h2>
					<Level
						max={currQuiz.catData.level.max_value}
						//@ts-ignore
						current={
							question.is_700
								? question.level_700
								: question.level
						}
					/>
				</div>

				<div className={s.quiz}>
					<div className={s.timer}>
						<div
							className={cn(s.timer_inner, {
								[s.timer_inner__hide]: !showTimer,
							})}>
							{usingTimes ? (
								<CountdownCircleTimer
									key={timerKey}
									isPlaying={isPlaing}
									duration={currQuiz.catData.time}
									colors="#2d2c50"
									trailColor="#ffb84b"
									size={144}
									strokeWidth={4}
									strokeLinecap="round"
									onComplete={onTimeEnd}>
									{RenderTime}
								</CountdownCircleTimer>
							) : (
								<StopWatch
									doPause={!swIsPlayinbg}
									currentId={stopWatchId}
									getTimePassedCallBack={
										getTimePassedCallBack
									}
								/>
							)}
						</div>
					</div>
					<div className={s.quiz_hdr}>
						<div className={s.quiz_hdr_half}>
							<div className={s.nonstop}>
								<input
									className={s.nonstop_inp}
									name="nonstop"
									id="nonstop"
									type="checkbox"
									checked={isNoneStop}
									onChange={() => setIsNoneStop(!isNoneStop)}
								/>
								<label
									htmlFor="nonstop"
									className={s.nonstop_lbl}>
									המשך מיד לשאלה הבאה
								</label>
							</div>
							{currBundle && bundleStarted && (
								<Button
									onClick={() =>
										setBundleExpanded(!bundleExpanded)
									}
									color="blue"
									width="full"
									size="small"
									isWithIcon>
									<SvgExpand />
									{bundleExpanded
										? 'הסתר קטע/תרשים'
										: 'הצג קטע/תרשים'}
								</Button>
							)}
						</div>
						<div className={s.quiz_hdr_half}>
							<Switch
								id={'timeSwitch'}
								lbl={'הצגת שעון'}
								isOn={showTimer}
								updateState={() => setShowTimer(!showTimer)}
							/>
						</div>
					</div>
					{currBundle && (
						<BundleContent
							content={currBundle.content}
							show={bundleExpanded}
						/>
					)}
					{currBundle && !bundleStarted && (
						<Button
							onClick={startBundle}
							width="full-inline"
							fillMode="fill"
							color="yellow">
							הצגת שאלות
						</Button>
					)}
					{showQuestion && (
						<SingleQuestion
							q={question}
							isTimed={isTimed}
							showSolution={showSolution}
							onAnswerSelectCallback={onAnswerSelectCallback}
						/>
					)}
				</div>
				{question.status !== undefined && (
					<button
						className={s.btn_solu}
						onClick={() => setShowSolution(!showSolution)}>
						{showSolution ? 'הסתר פתרון' : 'הצג פתרון'}
					</button>
				)}
				<div className={s.quiz_ftr}>
					{totalQuestionsLeft > 1 &&
						!(currBundle && !bundleStarted) && (
							<Button
								onClick={() => moveToNextQuestion('click')}
								width="full-inline"
								fillMode="fill"
								color="yellow">
								עבור לשאלה הבאה
							</Button>
						)}

					<Link
						to="/summary"
						state={{
							questions: usedQuestions.current,
							bundles: usedBundles.current,
							categories: categories,
						}}>
						<Button
							width="full-inline"
							fillMode="empty"
							color="blue"
							customClass={s.btn_order}>
							סיים את התרגול
						</Button>
					</Link>

					{/* <QuestionPagination
                        current={currIndex}
                        max={questions.length}
                        updateIndex={index => setCurrIndex(index)}
                    /> */}
				</div>
			</section>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setModalIsOpen(false)}
				contentLabel="תמונה"
				closeTimeoutMS={300}
				className={{
					base: s['m__content'],
					afterOpen: s['m__content--after-open'],
					beforeClose: s['m__content--before-close'],
				}}
				overlayClassName={{
					base: s['m__overlay'],
					afterOpen: s['m__overlay--after-open'],
					beforeClose: s['m__overlay--before-close'],
				}}
				appElement={root}>
				<div
					className={s.m__content_inner}
					dangerouslySetInnerHTML={{
						__html: modalContent?.innerHTML ?? '',
					}}
				/>
				<button
					className={s.m__btn}
					onClick={() => setModalIsOpen(false)}>
					X
				</button>
			</Modal>
			<Modal
				isOpen={timeModalIsOpen}
				onRequestClose={() => closeTimeModal('show-solution')}
				contentLabel="בחירת פעולה"
				closeTimeoutMS={300}
				className={{
					base: s['mt__content'],
					afterOpen: s['mt__content--after-open'],
					beforeClose: s['mt__content--before-close'],
				}}
				overlayClassName={{
					base: s['mt__overlay'],
					afterOpen: s['mt__overlay--after-open'],
					beforeClose: s['mt__overlay--before-close'],
				}}
				appElement={root}>
				<div className={s.mt__content_inner}>
					<SvgSendTimer />
					<div className={s.mt__content_txt}>אזל הזמן...</div>
				</div>
				<div className={s.mt__content_btns}>
					<Button
						onClick={() => closeTimeModal('show-solution')}
						width={'inline'}
						size={isModile ? 'small' : 'normal'}>
						הצגת פתרון
					</Button>

					{totalQuestionsLeft > 1 &&
					!(currBundle && bundleExpanded) ? (
						<Button
							onClick={() => closeTimeModal('next')}
							width="inline"
							color="yellow"
							fillMode="fill"
							size={isModile ? 'small' : 'normal'}>
							קדימה, לשאלה הבאה
						</Button>
					) : (
						<Link
							to="/summary"
							state={{
								questions: usedQuestions.current,
								bundles: usedBundles.current,
								categories: categories,
							}}>
							<Button
								width="full-inline"
								fillMode="empty"
								color="blue"
								customClass={s.btn_order}>
								סיים את התרגול
							</Button>
						</Link>
					)}
				</div>
				<div className={s.mt__content_showtmodal}>
					<input
						className={s.nonstop_inp}
						name="showTimeModal"
						id="showTimeModal"
						type="checkbox"
						checked={!showTimeModal}
						onChange={() => setShowTimeModal(!showTimeModal)}
					/>
					<label htmlFor="showTimeModal" className={s.nonstop_lbl}>
						אל תציגו לי מסך זה בפעם הבאה
					</label>
				</div>
			</Modal>
		</>
	);
};
export default Quiz2;
